import React from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { AxiosInterceptors, Layout } from 'components';
import { PageNotFound, Unlock } from 'pages';
import { routeNames, routes } from 'routes';

export const App = () => {
  return (
    <Router>
      <AxiosInterceptors>
        <Layout>
          <Routes>
            <Route path={routeNames.unlock} element={<Unlock />} />
            {routes.map((route, index) => (
              <Route
                path={route.path}
                key={'route-key-' + index}
                element={<route.component />}
              />
            ))}
            <Route path='*' element={<PageNotFound />} />
          </Routes>
        </Layout>
      </AxiosInterceptors>
    </Router>
  );
};
